'use strict';

exports.__esModule = true;

var _utils = require('../utils');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * Created by @玩家 on 2017/2/7.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */


exports['default'] = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(req) {
        var jsonp, jsonpCallback, timeout, query, url, scriptId, jsonpScript, jsonpPromise, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        jsonp = req.jsonp, jsonpCallback = req.jsonpCallback, timeout = req.timeout;

                        jsonpCallback = jsonpCallback || generateCallbackFunction();
                        query = req.query;

                        query[jsonp] = jsonpCallback;
                        query['_'] = new Date().getTime();
                        req.query = query;
                        url = req.url;
                        scriptId = 'jsonp_' + jsonpCallback;
                        jsonpScript = document.createElement('script');

                        jsonpScript.id = scriptId;
                        jsonpScript.setAttribute('src', url);
                        document.getElementsByTagName('head')[0].appendChild(jsonpScript);

                        jsonpPromise = new Promise(function (resolve) {
                            window[jsonpCallback] = function (response) {
                                resolve({
                                    ok: true,
                                    body: response
                                });
                            };
                        });
                        _context.next = 15;
                        return Promise.race([jsonpPromise, (0, _utils.delay)(timeout)]);

                    case 15:
                        response = _context.sent;

                        // clearFunction(jsonpCallback);
                        removeScript(scriptId);
                        return _context.abrupt('return', response);

                    case 18:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function jsonpFetcher(_x) {
        return _ref.apply(this, arguments);
    }

    return jsonpFetcher;
}();

// Known issue: Will throw 'Uncaught ReferenceError: callback_*** is not defined' error if request timeout


function clearFunction(functionName) {
    delete window[functionName];
}

function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    document.getElementsByTagName('head')[0].removeChild(script);
}

function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
}
module.exports = exports['default'];